"use strict";

require("core-js/modules/es6.object.define-properties");

require("core-js/modules/es7.object.get-own-property-descriptors");

require("core-js/modules/es6.array.for-each");

require("core-js/modules/es6.array.filter");

require("core-js/modules/es6.symbol");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = require("react");

var _border = _interopRequireDefault(require("polished/lib/shorthands/border"));

var _position = _interopRequireDefault(require("polished/lib/shorthands/position"));

var _useTheme2 = _interopRequireDefault(require("../../styles/useTheme"));

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        (0, _defineProperty2["default"])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"].signature : function (a) {
  return a;
};

var useStyles = function useStyles() {
  var color = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'lightBackground';
  var borderColor = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'inactive';
  var elevation = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;

  var _useTheme = (0, _useTheme2["default"])(),
      colors = _useTheme.colors,
      spacing = _useTheme.spacing,
      boxShadow = _useTheme.boxShadow;

  return (0, _react.useMemo)(function () {
    return {
      root: {
        position: 'relative',
        boxShadow: 'none',
        border: 'none'
      },
      bottom: {
        touchAction: 'pan-y',
        ':after': _objectSpread({
          content: '""',
          overflowY: 'hidden',
          zIndex: -1,
          height: spacing(1000),
          backgroundColor: colors[color],
          borderRadius: spacing(4),
          boxShadow: boxShadow('shadow', elevation)
        }, (0, _position["default"])('absolute', '-1px', '-1px', 'auto', '-1px'), {}, (0, _border["default"])('left', '1px', 'solid', colors[borderColor]), {}, (0, _border["default"])('right', '1px', 'solid', colors[borderColor]))
      },
      top: {
        touchAction: 'pan-y',
        ':after': _objectSpread({
          content: '""',
          overflowY: 'hidden',
          zIndex: -1,
          height: spacing(1000),
          backgroundColor: colors[color],
          borderRadius: spacing(4),
          boxShadow: boxShadow('shadow', elevation)
        }, (0, _position["default"])('absolute', 'auto', '-1px', '-1px', '-1px'), {}, (0, _border["default"])('left', '1px', 'solid', colors[borderColor]), {}, (0, _border["default"])('right', '1px', 'solid', colors[borderColor]))
      },
      right: {
        touchAction: 'pan-x',
        ':after': _objectSpread({
          content: '""',
          overflowX: 'hidden',
          zIndex: -1,
          width: spacing(1000),
          backgroundColor: colors[color],
          borderRadius: spacing(4),
          boxShadow: boxShadow('shadow', elevation)
        }, (0, _position["default"])('absolute', '-1px', 'auto', '-1px', '-1px'), {}, (0, _border["default"])('top', '1px', 'solid', colors[borderColor]), {}, (0, _border["default"])('bottom', '1px', 'solid', colors[borderColor]))
      },
      left: _objectSpread({
        touchAction: 'pan-x',
        borderRadius: spacing(0, 4, 4, 0)
      }, (0, _border["default"])('left', '1px', 'solid', colors[color]), {
        ':after': _objectSpread({
          content: '""',
          overflowX: 'hidden',
          zIndex: -1,
          width: spacing(1000),
          backgroundColor: colors[color],
          borderRadius: spacing(4),
          boxShadow: boxShadow('shadow', elevation)
        }, (0, _position["default"])('absolute', '-1px', '-1px', '-1px', 'auto'), {}, (0, _border["default"])('top', '1px', 'solid', colors[borderColor]), {}, (0, _border["default"])('bottom', '1px', 'solid', colors[borderColor]))
      })
    };
  }, [colors, spacing, boxShadow]);
};

__signature__(useStyles, "useTheme{{ colors, spacing, boxShadow }}\nuseMemo{}", function () {
  return [_useTheme2["default"]];
});

var _default = useStyles;
var _default2 = _default;
exports["default"] = _default2;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"] : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(useStyles, "useStyles", "/builds/bA1zbJom/0/gojob/ui-bits/src/SlideableDrawer/Drawer/useStyles.ts");
  reactHotLoader.register(_default, "default", "/builds/bA1zbJom/0/gojob/ui-bits/src/SlideableDrawer/Drawer/useStyles.ts");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();